import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function CookiesPage() {
    return (
        <div className="container-page py-12 max-w-4xl text-slate-700 dark:text-slate-300">
            <SEO
                title="Cookie Policy"
                description="Understand how AuraIcon uses cookies to improve your experience. Learn about essential, analytics, and functionality cookies."
                canonical="/cookies"
            />
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-8">Cookie Policy</h1>

            <div className="space-y-8">
                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">1. What Are Cookies?</h2>
                    <p className="leading-relaxed">
                        Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">2. How We Use Cookies</h2>
                    <p className="leading-relaxed mb-4">
                        We use cookies for the following purposes:
                    </p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><strong>Essential Cookies:</strong> These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas (via Auth0).</li>
                        <li><strong>Analytics Cookies:</strong> These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are (via Google Analytics).</li>
                        <li><strong>Functionality Cookies:</strong> These cookies allow our website to remember choices you make when you use our website, such as remembering your login details or language preference.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">3. Managing Cookies</h2>
                    <p className="leading-relaxed">
                        You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">4. More Information</h2>
                    <p className="leading-relaxed">
                        For more information about your privacy and how we handle your data, please read our <Link to="/privacy" className="text-violet-600 dark:text-violet-400 hover:underline">Privacy Policy</Link>.
                    </p>
                </section>

                <p className="text-sm text-slate-500 mt-12 pt-8 border-t border-slate-200 dark:border-white/10">
                    Last updated: {new Date().toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}
